import { useAuth } from './useAuth'
import {
  useGetUserSettingsByIdUsername,
  useUpdateUserSettingsMutation
} from './useUser'
import { Theme } from './useTheme'
import { Settings } from './useAvdeling'
import { Filters } from './useFilters'
import { CombinationStatus } from '../types/types'

export interface UserSettings {
  theme?: Theme
  avdeling?: Settings
  filterCombinations?: Filters<CombinationStatus>
  filtersTasks?: Filters<string>
  filterRequisitions?: Filters<string>
  filterPlanSamples?: Filters<string>
  filterTakeSamples?: Filters<string>
  filterPlans?: Filters<string>
  betaFeaturesEnabled?: {
    [featureName: string]: boolean
  }
}

export const useSettings = () => {
  const { userId } = useAuth()
  const userSettings = useGetUserSettingsByIdUsername(userId)
  const editUserSettings = useUpdateUserSettingsMutation()
  const userSettingsGetParsed = userSettings.isSuccess
    ? (JSON.parse(userSettings.data?.settings) as UserSettings)
    : {}

  const setSettings = (settings: UserSettings): void => {
    if (userId != undefined) {
      editUserSettings.mutate({
        username: userId,
        body: {
          settings: JSON.stringify({ ...settings })
        }
      })
    }
  }

  return {
    get: userSettingsGetParsed,
    set: setSettings,
    isSuccess: userSettings.isSuccess,
    isPending: userSettings.isPending,
    isError: userSettings.isError
  }
}
